"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  tariffs: {
    title: 'DEM&DET Tariff',
    outboundDEM: 'Outbound Demurrage & Detention of SITC Container Lines Co.,Ltd',
    inboundDEM: 'Inbound Demurrage & Detention of SITC Container Lines Co.,Ltd',
    tips_1: 'CHINA DOMESTIC DETENTION TARIFF ACCORDING TO LOCAL STANDARD'
  }
};